import { defineStore } from 'pinia';
import { ColorTranslator } from 'colortranslator';
import { useStorage } from '@vueuse/core';
import SettingsService from '../services/SettingsService';

export const useThemeStore = defineStore('plugin:theme', () =>
{
    const state = useStorage('theme', {
        name: 'light',
        colors: {
            primary: '',
            secondary: '',
            nav: {
                bg: '',
                color: ''
            },
            menu: {
                active: {
                    color: ''
                }
            }
        },
        locale: ''
    },
    localStorage,
    { mergeDefaults: true });

    const theme = computed(() => state.value.name);
    const colors = computed(() => state.value.colors);
    const locale = computed({
        get: () => state.value.locale,
        set: (value) =>
        {
            state.value.locale = value;
        }
    });

    function changeTheme()
    {
        state.value.name = state.value.name === 'light' ? 'dark' : 'light';

        setTheme(theme.value);
    }

    async function initColors()
    {
        try
        {
            const result = await SettingsService.fetch('colors');

            colors.value.primary = result.primary;
            colors.value.secondary = result.secondary;
            colors.value.nav.bg = result.navBackground;
            colors.value.nav.color = result.navColor;
            colors.value.menu.active.color = result.menuColor;

            updateColors();
        }
        catch
        {
            colors.value.primary = '';
            colors.value.secondary = '';
            colors.value.nav.bg = '';
            colors.value.nav.color = '';
            colors.value.menu.active.color = '';
        }
    }

    function updateColors()
    {
        const root = document.documentElement.style;

        if (state.value.colors.primary)
        {
            const primary = new ColorTranslator(colors.value.primary);

            root.setProperty('--theme-primary', primary.HEX);
        }
    }

    function setTheme(name: string)
    {
        const isDark = name === 'dark';

        document.body.classList.add('pause-transition');
        document.documentElement.classList.toggle('dark', isDark);
        setTimeout(() => document.body.classList.remove('pause-transition'), 0);
    }

    setTheme(theme.value);

    return { theme, locale, colors, changeTheme, initColors, updateColors };
});
